import React from 'react';
import { useIntl } from 'react-intl';

import Container from '@/components/Container/Container';
import PageNext from '@/components/Page/PageNext';
import Typography from '@/components/Typography/Typography';
import { NextPage } from '@/pages/_app';

const TermsOfUsePage: NextPage = () => {
  const intl = useIntl();
  return (
    <PageNext title={intl.formatMessage({ id: 'app.personaldataprocessingconsent.pagetitle' })}>
      <Container maxWidth="md" verticalPadding>
        <Typography variant="h2" component="h1" spacing={4}>
          ЛИЦЕНЗИОННОЕ СОГЛАШЕНИЕ (В ФОРМЕ ПУБЛИЧНОЙ ОФЕРТЫ)
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          В редакции от: «30» октября 2019 года
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          ПЕРЕД НАЧАЛОМ ИСПОЛЬЗОВАНИЯ САЙТА ПРОСИМ ВАС ВНИМАТЕЛЬНО ОЗНАКОМИТЬСЯ С НАСТОЯЩИМ ДОКУМЕНТОМ. ИСПОЛЬЗОВАНИЕ
          САЙТА РАЗРЕШАЕТСЯ ТОЛЬКО ПРИ СОБЛЮДЕНИИ УСЛОВИЙ ДАННОГО СОГЛАШЕНИЯ. ПРИНИМАЯ НАСТОЯЩЕЕ СОГЛАШЕНИЕ, ВЫ БЕРЕТЕ
          НА СЕБЯ ОБЯЗАТЕЛЬСТВО СОБЛЮДАТЬ СОГЛАШЕНИЕ, ПРИВЕДЕННОЕ НИЖЕ.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          ООО «Смарт Манкиз» (далее по тексту – Лицензиар) предлагает заключить Лицензионное соглашение (далее по тексту
          – Соглашение) неограниченному кругу лиц, использующих сайт (далее по тексту – Лицензиат), размещенный в сети
          интернет по адресу: https://geecko.ru (далее по тексту – Сайт).
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          Соглашение является публичной офертой в соответствии с п. 2 ст. 437 ГК РФ. В соответствии со статьей 438
          Гражданского кодекса РФ принятием условий настоящего Соглашения считается совершение действий, изложенных в
          Соглашении. Договор, заключаемый путем акцепта настоящей оферты, не требует двустороннего подписания и
          действителен в электронном виде.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          Безусловным акцептом Лицензиатом Соглашения является Регистрация на Сайте путем заполнения электронной формы и
          установления флажка напротив фразы «С условиями Лицензионного соглашения ознакомился и согласен» и нажатия
          кнопки «Регистрация».
        </Typography>
        <Typography variant="h2" component="h1" spacing={4}>
          ТЕРМИНЫ
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          Стороны используют указанные термины в следующем значении:
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          1. Ассесмент – оценка профессиональных навыков Лицензиата с целью отбора на Вакансию.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          2. Вакансия – описание вакантной должности Работодателя.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          3. Контент – любые текстовые, графические, аудио, видео, и иные материалы, размещенные на Сайте.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4. Лицензиат – физическое лицо (достигшее возраста совершеннолетия в соответствии с законодательством
          юрисдикции своего проживания, но не менее 18 лет), юридическое лицо или индивидуальный предприниматель,
          акцептовавший Соглашение.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5. Личный кабинет – совокупность защищенных страниц на Сайте, создаваемых при Регистрации Лицензиата,
          посредством которых Лицензиат использует функционал Сервиса и осуществляется взаимодействие сторон по
          Соглашению.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          6. Логин и пароль – уникальный набор символов, создаваемый Лицензиатом при прохождении Регистрации,
          предназначенный для доступа к Личному кабинету.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          7. Неисключительная лицензия – безвозмездное предоставление неисключительного права использования Сайта и
          Сервиса посредством удаленного доступа путем воспроизведения интерфейса Сайта и/или страницы Сайта на
          техническом устройстве с помощью браузера посредством авторизации Лицензиата c помощью Логина и пароля.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          8. Работодатель – лицо, заинтересованное в поиске лиц для замещения Вакансии.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          9. Регистрация – бесплатный процесс заполнения электронной формы, расположенной на Сайте, установление флажка
          напротив фразы «С условиями Лицензионного соглашения ознакомился и согласен» и отправки формы Лицензиару путем
          нажатия кнопки «Регистрация».
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          10. Сайт – сайт, размещенный в сети Интернет по адресу https://geecko.ru.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          11. Сервис – программно-аппаратный комплекс, расположенный на Сайте, посредством которого предоставляется
          возможность поиска Вакансии и взаимодействия с Работодателем.
        </Typography>
        <Typography variant="h2" component="h1" spacing={4}>
          2. ПРЕДМЕТ
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          2.1. В соответствии с Соглашением Лицензиар предоставляет Лицензиату доступ к Сайту и Сервису на условиях
          Неисключительной лицензии, не подлежащей переуступке.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          2.2. Территория передаваемых прав – все страны мира.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          2.3. Срок передаваемых прав – ограничен сроком действия Соглашения.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          2.4. Лицензиар подтверждает, что обладает всеми исключительными правами в отношении Сайта и Сервиса.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          2.5. Лицензиат подтверждает, что, совершая акцепт, он ознакомился с условиями настоящего Соглашения и условия
          Соглашения ему понятны.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          2.6. Текст настоящего Соглашения размещен на Сайте. Лицензиар вправе в любой момент изменить настоящее
          Соглашение. Условия Соглашения не могут быть изменены, кроме как посредством опубликования изменённого
          документа на Сайте.
        </Typography>
        <Typography variant="h2" component="h1" spacing={4}>
          3. РЕГИСТРАЦИЯ
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          3.1. Регистрация считается оконченной в момент отправки Лицензиару заполненной электронной формы на Сайте
          Лицензиара.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          3.2. Перед отправкой электронной формы Лицензиат обязан ознакомиться с положениями Соглашения, а также
          Политикой конфиденциальности и текстом Согласия на обработку персональных данных, размещенных на Сайте.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          3.3. Лицензиат заверяет и гарантирует, что:
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          3.3.1. Персональные данные, указанные им при Регистрации, являются актуальными и достоверными и не относятся к
          третьему лицу.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          3.3.2. Условия Соглашения и текст Согласия на обработку персональных ему понятны и принимаются полностью.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          3.4. Лицензиар оставляет за собой право устанавливать процедуру подтверждения регистрации, а также вводить
          требования к Логину и паролю Лицензиата в целях обеспечения безопасности учетной записи.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          3.5. Лицензиат несет персональную ответственность за безопасность и устойчивость к взлому третьими лицами
          выбранного Лицензиатом пароля, а также самостоятельно обеспечивает его конфиденциальность. Лицензиат обязуется
          не сообщать третьим лицам Логин и пароль, указанные при регистрации.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          3.6. Лицензиат подтверждает, что любые действия, совершенные под его учетной записью (включая, без
          ограничений, нажатие кнопок подтверждения согласия с любыми соглашениями и правилами) будут расцениваться как
          санкционированные самим Лицензиатом, если не доказано обратное.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          3.7. Лицензиар оставляет за собой право проверять предоставленные Лицензиатом данные на соответствие пункту
          3.3.1. настоящего Соглашения. В случае если Лицензиар посчитает предоставляемые Лицензиатом данные не
          соответствующими пункту 3.3.1. настоящего Соглашения, Лицензиар оставляет за собой право не предоставлять
          Лицензиату доступ в Личный кабинет и (или) заблокировать доступ к Личному кабинету.
        </Typography>
        <Typography variant="h2" component="h1" spacing={4}>
          4. ИСПОЛЬЗОВАНИЕ САЙТА И СЕРВИСА
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          4.1. Обязательства Лицензиара по предоставлению Неисключительной лицензии считаются исполненными в момент
          окончания Регистрации.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.2. Стороны признают юридическую силу за электронными письмами – документами, отправленными по электронной
          почте (e-mail) и в соответствующий раздел Личного кабинета Лицензиата, и признают их равнозначными документам
          на бумажных носителях, подписанным собственноручной подписью, так как только сами Стороны и уполномоченные ими
          лица имеют доступ к соответствующим средствам связи – адресам электронной почты и доступу в Личный кабинет.
          Стороны пришли к соглашению, что акт предоставления Неисключительной лицензии не составляется.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.3. Используя функционал Сервиса, Лицензиат имеет право:
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.3.1. Пройти Ассесмент.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.3.2. Получать тестовые задания для отбора на Вакансию.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.3.3. Получать предложения о прохождении собеседований от Работодателей.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.3.4. Взаимодействовать с Работодателем по итогам проведенных собеседований, в том числе получать предложения
          о заключении договора с Работодателем.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.3.5. Загружать, публиковать, делать иным образом доступной на Сервисе информацию, тем самым предоставляя
          Лицензиару безвозмездную, неисключительную, действующую во всем мире лицензию на использование такой
          информации на срок действия исключительных прав. Лицензиар не обязан предоставлять Лицензиату отчетов об
          использовании размещенной им информации.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.3.6. Лицензиат соглашается, что при прохождении Ассесмента данные могут быть переданы Работодателю.
          Результаты Ассесмента не могут быть оспорены Лицензиатом.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.4. При использовании Сервиса запрещается:
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.4.1. Использовать Сервис способом, прямо не предусмотренным Соглашением, осуществлять использование Сервиса
          или его частей за пределами срока действия Соглашения.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.4.2. Распространять, копировать или иным образом осуществлять обнародование программного обеспечения,
          входящего в Сервис.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.4.3. Использовать Сайт и Сервис для участия в деятельности аналогичной деятельности Лицензиара.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.4.4. Загружать, публиковать, направлять посредством Сервиса другим Лицензиатам, в том числе Работодателям
          любую информацию, которая нарушает требования действующего законодательства или которая по мнению Лицензиара
          нарушает права и интересы других граждан и юридических лиц или по другим причинам является нежелательной для
          размещения на Сервисе, включая, но не ограничиваясь, информацию, которая нарушает интеллектуальные права
          третьих лиц, содержит угрозы, дискредитирует, оскорбляет, порочит честь и достоинство или деловую репутацию
          или нарушает неприкосновенность частной жизни других Лицензиатов или третьих лиц, содержит нецензурную
          лексику, содержит порнографические изображения, пропагандирует и (или) способствует разжиганию расовой,
          религиозной, этнической ненависти или вражды, содержит информацию ограниченного доступа, включая, но не
          ограничиваясь, государственную и коммерческую тайну.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.4.5. Распространять какое-либо вредоносное программное обеспечение, которое повреждает, препятствует,
          перехватывает, экспроприирует, иным образом нарушает целостность программных или аппаратных систем, связанных
          с настоящим Сайтом и Сервисом, а также или личной информации других Лицензиатов.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.5. Лицензиат, используя функционал Сервиса, обязан сообщить Лицензиару о факте заключения договора с
          Работодателем, включая дату заключения договора и размер ежемесячного вознаграждения. По запросу Лицензиара
          Лицензиат обязан предоставить копию договора с Работодателем.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.6. Лицензиат обязуется соблюдать иные условия настоящего Соглашения.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.7. Доступ к Сервису предоставляется круглосуточно, за исключением случаев проведения профилактических работ.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.8. Лицензиар имеет право проводить профилактические работы на сервере, для чего временно приостанавливать
          доступ к Сервису. О профилактических работах Лицензиар уведомляет Лицензиата путем оповещения на Сайте.
          Проведение профилактических работ будет осуществляться по возможности в вечернее или ночное время и/или в
          выходные дни.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.9. Лицензиар имеет право модифицировать или выпускать обновления Сервиса, добавлять новые свойства или
          функциональные возможности программного обеспечения, повышающие его работоспособность или иным способом
          улучшающие его характеристики, либо исключать соответствующий функционал.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.10. Лицензиар имеет право заблокировать доступ Лицензиата к Личному кабинету, а также наложить иные
          ограничения на использование Сайта и Сервиса, если Лицензиар будет иметь разумные основания полагать, что
          Лицензиат нарушает условия настоящего Соглашения.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.11. Лицензиар имеет право устанавливать ограничения в использовании Сайта и Сервиса для некоторых категорий
          Лицензиатов, что зависит в частности, но не ограничиваясь, от территории нахождения Лицензиата, языка, на
          котором предоставляется Сайт и Сервис, предельного размера информации, которая может быть загружена
          Лицензиатом на Сервис.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          4.12. Не проверять содержание любой информации, передаваемой Лицензиатом через Сайт.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          4.13. Расторгнуть настоящее Соглашение с Лицензиатом и отказаться от его исполнения в случае невыполнения
          Лицензиатом условий настоящего Соглашения. В любой момент изменить текст настоящего Соглашения в одностороннем
          порядке.
        </Typography>
        <Typography variant="h2" component="h1" spacing={4}>
          5. ОТВЕТСТВЕННОСТЬ И ПОРЯДОК РАЗРЕШЕНИЯ СПОРОВ
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.1. Лицензиар прилагает все возможные усилия для обеспечения работоспособности Сайта и Сервиса, однако не
          гарантирует его постоянную доступность, бесперебойное и своевременное предоставление, безопасность, точность,
          отсутствие ошибок в работе Сайта и Сервиса. Единственно доступной возможностью Лицензиата в связи с указанными
          выше проблемами является немедленное прекращение использования Сайта и Сервиса.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.2. Сайт и Сервис предоставляется Лицензиату «как есть» (as is), в соответствии с общепринятым в
          международной практике принципом. Лицензиар не несет ответственности за проблемы, возникающие в процессе
          установки, обновления, поддержки и эксплуатации системы (в т. ч. проблемы совместимости с другими программными
          продуктами (пакетами, драйверами и др.), несоответствия результатов использования Сервиса ожиданиям Лицензиата
          и т. п.). Лицензиат должен понимать, что несет полную ответственность за возможные негативные последствия,
          вызванные несовместимостью или конфликтами Системы с другими программными продуктами, установленными на
          компьютере или ином устройстве Лицензиата. Сервис не предназначен и не может быть использован в информационных
          системах, работающих в опасных средах либо обслуживающих системы жизнеобеспечения, в которых сбой в работе
          Сервиса может создать угрозу жизни людей или повлечь большие материальные убытки.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.3. Лицензиар не несет никакой ответственности, будь то договорная ответственность или ответственность из
          причинения вреда, вне зависимости от того, был Лицензиат оповещен о возможности наступления указанных
          нарушений или ущерба, связанного или являющегося следствием использования Сервиса Лицензиаром, в том числе, не
          ограничиваясь, за ущерб, наступивший в результате:
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.3.1. Загрузки Лицензиатом или иного получения данных через Сайт и Сервис. Никакие рекомендации, полученные
          Лицензиатом в устной или письменной форме от Лицензиара, не создают никаких гарантий.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.3.2. Разглашения третьим лицам информации, содержащейся в Личном кабинете Лицензиата, произошедшего не по
          вине Лицензиара.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.3.3. Проведения Лицензиаром профилактических работ на Сервисе с одновременным прекращением использования
          Сервиса Лицензиатом.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.3.4. Действий (бездействий) других Лицензиатов и третьих лиц, Работодателей, в том числе за неисполнение
          Работодателем обязательств перед Лицензиатом.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.4. Лицензиат самостоятельно несет ответственность за сохранность своего Логина и пароля и за убытки, которые
          могут возникнуть по причине несанкционированного их использования.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.5. Лицензиат самостоятельно несет ответственность за соответствие всей информации, размещаемой на Сервисе,
          требованиям действующего законодательства, включая ответственность перед третьими лицами в случаях, когда
          размещение Лицензиатом такой информации на Сервисе или ее содержание нарушает права и законные интересы
          третьих лиц. Лицензиар вправе подвергать редактированию (модерации) информацию, которую Лицензиат разместил на
          Сервисе.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.6. При любых обстоятельствах ответственность Лицензиара ограничивается суммой в размере 1 000 руб.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.7. В случае возникновения споров между Лицензиатом и Лицензиаром, вытекающих из настоящего Соглашения,
          претензионный порядок их урегулирования является обязательным.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.8. Лицензиат вправе направить письменную мотивированную претензию в адрес Лицензиара, если считает, что
          Лицензиар нарушает условия настоящего Соглашения. Претензии, не позволяющие идентифицировать Лицензиата, не
          рассматриваются.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.9. Лицензиар вправе направить письменную мотивированную претензию в адрес Лицензиата, который по мнению
          Лицензиара нарушает условия настоящего Соглашения.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          5.10. Срок для рассмотрения претензии составляет 10 (десять) дней со дня ее получения адресатом.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          5.11. В случае не достижения разрешения спора, вытекающего из настоящего Соглашения в претензионном порядке,
          спор подлежит рассмотрению в суде по месту нахождения Лицензиара.
        </Typography>
        <Typography variant="h2" component="h1" spacing={4}>
          6. КОНФИДЕНЦИАЛЬНОСТЬ И БЕЗОПАСНОСТЬ
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          6.1. Лицензиар ответственно относится к сохранению неприкосновенности частной жизни и конфиденциальной
          информации. Лицензиар хранит и обрабатывает предоставленную Лицензиатом информацию, строго придерживаясь
          Политики конфиденциальности, размещенной на Сайте, в соответствии с требованиями федерально закона «О
          персональных данных» от 27.07.2006 No152-ФЗ.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          6.2. Лицензиар в ходе своей деятельности может предоставлять и (или) поручать обработку персональных данных
          Работодателю с согласия Лицензиата, если иное не предусмотрено законодательством РФ о персональных данных. При
          этом обязательным условием предоставления и (или) поручения обработки персональных данных другому лицу
          является обязанность сторон по соблюдению конфиденциальности и обеспечению безопасности персональных данных
          при их обработке.
        </Typography>
        <Typography variant="h2" component="h1" spacing={4}>
          7. РАССЫЛКА
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          7.1. Лицензиар уважает право каждого Лицензиата получать только такие сообщения, на получение которых он
          выразил свое согласие.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          7.2. Лицензиар осуществляет рассылку сообщений исключительно на добровольной основе, а также прилагает все
          усилия для того, чтобы взаимодействие между Лицензиатом и Сервисом было максимально удобным и доверительным.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          7.3. Лицензиар с большим вниманием относится к проблеме незапрошенных рекламных сообщений, носящих массовый
          характер (далее по тексту – Спам). В связи с этим Лицензиаром приняты следующие меры для борьбы со Спамом:
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          7.3.1. Получение от Лицензиата предварительного согласия на осуществление рассылки сообщений Лицензиаром.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          7.3.2. Включение в текст каждого сообщения достоверных идентификационных сведений о Лицензиаре.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          7.3.3. Предоставление Лицензиату возможности отказаться от рассылки сообщений, осуществляемой Лицензиаром.
        </Typography>
        <Typography variant="h2" component="h1" spacing={4}>
          8. СРОК ДЕЙСТВИЯ СОГЛАШЕНИЯ. ПОРЯДОК РАСТОРЖЕНИЯ
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          8.1. Соглашение вступает в силу с даты акцепта и действует до расторжения Сторонами.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          8.2. Соглашение может быть расторгнуто любой из Сторон путем удаления Личного кабинета Лицензиата.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          8.3. Лицензиат обязуется самостоятельно следить за изменениями Соглашения и приложений к нему путем
          периодического ознакомления с актуальной редакцией, не менее одного раза в месяц. Лицензиат самостоятельно
          отвечает за любые последствия, наступившие в связи с не ознакомлением с Соглашением и приложениями к нему.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          8.4. В случае если Лицензиат не согласен с каким-либо положением Соглашения и (или) приложений к нему, он
          обязан незамедлительно прекратить использование Сайта и Системы.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          8.5. При расторжении настоящего Соглашения немедленно прекращается действие всех лицензий и прав на
          использование Сайта. Расторжение Соглашения не влияет на обязательства Лицензиата, налагаемые условиями
          настоящего Соглашения, перед Лицензиаром, которые в разумных пределах должны сохраняться и после расторжения
          Соглашения.
        </Typography>
        <Typography variant="h2" component="h1" spacing={4}>
          9. ПРОЧИЕ УСЛОВИЯ
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          9.1. Действие Неисключительной лицензии по Соглашению распространяется на все последующие обновления и новые
          версии Системы.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          9.2. Настоящее Соглашение исчерпывающим образом регулируют использование Лицензиатом Сайта и Сервиса, заменяя
          любые предшествующие письменные или устные договоренности в отношении содержания данного документа.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          9.3. Если какое-либо положение настоящего Соглашения либо его часть будет признано не имеющим юридической силы
          любым судебным, либо административным органом, обладающим надлежащей юрисдикцией, такое положение или его
          часть должны быть удалены из настоящего Соглашения без какого-либо ущерба для правомочности, действенности,
          возможности принудительного исполнения остальных положений настоящего Соглашения.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          9.4. Бездействие или задержка при реализации Лицензиаром своих законных прав или требований по возмещению
          ущерба, предусмотренных настоящим Соглашением, не означает отказа Лицензиара от своих законных прав.
        </Typography>
        <Typography variant="body3" component="div" spacing={1}>
          9.5. Названия разделов настоящего Соглашения устанавливаются исключительно в справочных целях и никаким
          образом не определяют, не ограничивают, не толкуют содержание соответствующего раздела.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          9.6. Действие настоящего Соглашения подчинено законодательству Российской Федерации.
        </Typography>
        <Typography variant="h2" component="h1" spacing={4}>
          10. РЕКВИЗИТЫ ЛИЦЕНЗИАРА
        </Typography>
        <Typography variant="body3" component="div" spacing={0}>
          ООО «Смарт Манкиз»
        </Typography>
        <Typography variant="body3" component="div" spacing={0}>
          Полное наименование: Общество с ограниченной ответственностью «Смарт Манкиз» Юридический адрес: 125008,
          Россия, г. Москва, проезд Черепановых, д. 36-91 Почтовый адрес: 125008, Россия, г. Москва, проезд Черепановых,
          д. 36-91
        </Typography>
        <Typography variant="body3" component="div" spacing={0}>
          ИНН/КПП: 7743264341/774301001
        </Typography>
        <Typography variant="body3" component="div" spacing={0}>
          ОГРН: 1187746655359
        </Typography>
        <Typography variant="body3" component="div" spacing={0}>
          Генеральный директор: Мещеряков Максим Павлович
        </Typography>
        <Typography variant="body3" component="div" spacing={0}>
          E-mail: max@geecko.ru
        </Typography>
        <Typography variant="body3" component="div" spacing={0}>
          Сайт: https://geecko.ru
        </Typography>
      </Container>
    </PageNext>
  );
};

export default TermsOfUsePage;
